import { useScrollReveal } from '@/hooks/useScrollReveal';

function CultureHero() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Panoramic%20celebration%20of%20African%20culture%20and%20heritage%2C%20artisans%20musicians%20dancers%20and%20colorful%20textiles%20in%20warm%20golden%20light%2C%20vibrant%20festive%20atmosphere%2C%20artistic%20stylized%20composition%2C%20rich%20terracotta%20amber%20and%20gold%20tones%2C%20professional%20editorial%20photography&width=1600&height=900&seq=culture-page-hero&orientation=landscape"
        alt="Culture & Patrimoine africain"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background-50" />

      <div className="relative z-10 w-full h-full flex items-end">
        <div
          ref={ref}
          className={`w-full px-4 md:px-8 lg:px-12 pb-14 md:pb-20 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-sm font-semibold text-accent-400 uppercase tracking-wider mb-4">
            Culture &amp; Patrimoine
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-foreground-50 max-w-3xl mb-4">
            Plongez au cœur de la richesse culturelle africaine
          </h1>
          <p className="text-base md:text-lg text-foreground-300 max-w-2xl">
            Six univers à explorer, des créateurs à rencontrer et un patrimoine vivant à célébrer.
            Art, musique, gastronomie, mode, traditions et tourisme : découvrez l&apos;Afrique sous
            toutes ses couleurs.
          </p>
        </div>
      </div>
    </section>
  );
}

export default CultureHero;